import axios from "axios"

export default function createGift({
    name,
    description,
    imgUrl,
    point,
    quantity,
    itemPerCustomer,
    status,
    startAt,
    endAt
}) {
    return new Promise((resolve, reject) => {
        axios.post("/campaign/api/admin/items",
            {
                name,
                description,
                imgUrl: imgUrl,
                point,
                quantity,
                itemPerCustomer,
                status,
                startAt,
                endAt
            })
            .then(response => resolve(response.data))
            .catch(error => reject(error.response.data))
    })
}